"use client";

import { useEffect, useState, type RefObject } from "react";

export function useMarketplaceMobilePinnedSearch(
  logoRowRef: RefObject<HTMLElement | null>,
  pinnedBlockRef: RefObject<HTMLElement | null>
) {
  const [logoHeight, setLogoHeight] = useState(0);
  const [pinnedBlockHeight, setPinnedBlockHeight] = useState(0);
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const update = () => {
      setLogoHeight(logoRowRef.current?.offsetHeight ?? 0);
      setPinnedBlockHeight(pinnedBlockRef.current?.offsetHeight ?? 0);
      setScrollY(window.scrollY);
    };

    update();

    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);

    const logoEl = logoRowRef.current;
    const pinnedEl = pinnedBlockRef.current;
    const observer =
      logoEl || pinnedEl ? new ResizeObserver(update) : null;

    if (logoEl) observer?.observe(logoEl);
    if (pinnedEl) observer?.observe(pinnedEl);

    return () => {
      window.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
      observer?.disconnect();
    };
  }, [logoRowRef, pinnedBlockRef]);

  const pinOffset = Math.max(0, logoHeight - scrollY);
  const isPinned = scrollY >= logoHeight;

  return { pinOffset, isPinned, pinnedBlockHeight };
}
